import React, { useEffect, useState } from 'react';
import CorrectAnswer from './CorrectAnswer';
import ProgressBar from './ProgressBar';
import ScoreBoard from './Scoreboard';
import SecurityExpert from './SecurityExpert';
import soundCorrectEE from '../assets/sound/ee_call/ee_call_true.mp3';
import soundFalseEE from '../assets/sound/ee_call/ee_call_fake.mp3';
import soundCorrectLT from '../assets/sound/lt_call/lt_call_true.mp3';
import soundFalseLT from '../assets/sound/lt_call/lt_call_fake.mp3';
import soundCorrectLV from '../assets/sound/lv_call/lv_call_true.mp3';
import soundFalseLV from '../assets/sound/lv_call/lv_call_fake.mp3';
import soundCorrectRU from '../assets/sound/ru_call/ru_call_true.mp3';
import soundFalseRU from '../assets/sound/ru_call/ru_call_fake.mp3';
import { useTranslation } from 'react-i18next';
import useGame from '../hooks/useGame';
import MultipleChoiceAnswer from './MultipleChoiceAnswer';
import SkipVideo from './SkipVideo';
import VideoFilesFullLoop from "./VideoFilesFullLoop";
import MobileVideoButton from './MobileVideoButton';
import { trackPageView } from '../helpers/gaHelper';

const Question9 = () => {
    const { PUBLIC_URL, REACT_APP_LANGUAGE } = process.env;
  const { t } = useTranslation();
  const { addScore, language, setIsListeningToAudio, trackGTMEvent } = useGame();

  useEffect(() => {
    trackPageView('/question/9');
  },[]);

  // wait
  async function wait(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  const [hasAnswered, setHasAnswered] = useState(false);
  const [score, setScore] = useState(2);
  const [isListeningA, setIsListeningA] = useState(false);
  const [isListeningB, setIsListeningB] = useState(false);

  const [showExtraTextA, setShowExtraTextA] = useState(false);
  const [showExtraTextB, setShowExtraTextB] = useState(false);

  const [correctSound, setCorrectSound] = useState(soundCorrectLT)
  const [wrongSound, setWrongSound] = useState(soundFalseLT)

  useEffect(() => {
    setIsListeningToAudio(isListeningA || isListeningB)
  }, [isListeningA, isListeningB])

  useEffect(() => {
    switch(language) {
      case 'et':
        setCorrectSound(soundCorrectEE);
        setWrongSound(soundFalseEE);
        break;
      case 'ru':
        setCorrectSound(soundCorrectRU)
        setWrongSound(soundFalseRU);
        break;
      case 'lt':
        setCorrectSound(soundCorrectLT)
        setWrongSound(soundFalseLT);
        break;
      case 'lv':
        setCorrectSound(soundCorrectLV)
        setWrongSound(soundFalseLV);
        break;
      default:
        setCorrectSound(soundCorrectEE);
        setWrongSound(soundFalseEE);
        break;
    }
  }, [language])

  const addBodyClass = className => document.body.classList.add(className);
  const removeBodyClass = className => document.body.classList.remove(className);

  useEffect(() => {
    const show = async () => {
      if (hasAnswered) {
        // show the screen after 1 second
        await wait(1000);

        setIsListeningToAudio(false)
        addBodyClass('fade-in-correct');

        return () => {
          removeBodyClass('fade-in-correct')
        }
      }
    }
    show();
  }, [hasAnswered])

  const handleAnswer = (isCorrect) => {
    if(isListeningA) {
      document.querySelectorAll('.listen')[0].click()
    }

    if(isListeningB) {
      document.querySelectorAll('.listen')[1].click()
    }

    if(isCorrect) {
      setHasAnswered(true)
      addScore(score);
    }
    else {
      setScore(score-1);
    }
  }

  // attach the main.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    trackGTMEvent(9);
  }, []);

  return (
    <main>
      <section className="question type-4">
        <div className="inner">
          <ScoreBoard />
          <ProgressBar question={9} />
          <SecurityExpert text={t('questions.9.expert')}/>
          <MobileVideoButton className="q9"/>
          <VideoFilesFullLoop page='q9' id='q9-video' />

          <div className="loop-screen q9" />
          <SkipVideo />

          <div className="question-wrapper">
            <h1>{t('questions.9.title')}</h1>

            <div className="select">

              <div className={`wave a ${showExtraTextA && 'extra'}`} data-path={correctSound}>
                <div className={`extra-text ${!showExtraTextA && 'hidden'}`}>
                  <span role='button' tabIndex={0} className="icon close-helper" close-message="1"
                    onClick={() => setShowExtraTextA(false)} 
                    onKeyDown={(evt) => {
                      if (evt?.keyCode === 13 || evt?.keyCode === 32) {
                        setTimeout(() => {
                          document.querySelector("[message='1']").focus();                           
                        }, 100);
                        return setShowExtraTextA(false)
                      }
                    }}
                  />
                  <div className="inner-text" id="text-a">
                    <p>{t('questions.9.extra_text_a')}</p>
                  </div>
                </div>
                <div tabIndex={-1} aria-hidden={'true'} className="wave-container" />
                <div className="wrap">
                  <button className="listen" onClick={() => setIsListeningA((isListeningA) => !isListeningA)}>{isListeningA ? t('questions.9.pause') : t('questions.9.listen')}</button>
                  <MultipleChoiceAnswer symbol={'A'} isCorrect={true} onClick={handleAnswer} />
                  <div role='button' tabIndex={0} className="read_message_text" message="1"
                    onClick={() => {
                      document.querySelector('[close-message="1"]').style.display = '';
                      document.querySelector('[close-message="1"]').setAttribute('tabindex', 0)
                      return setShowExtraTextA(true)
                    }}
                    onKeyDown={(evt) => {
                      if (evt?.keyCode === 13 || evt?.keyCode === 32) {
                        document.querySelector('[close-message="1"]').style.display = '';
                        document.querySelector('[close-message="1"]').setAttribute('tabindex', 0)

                        setTimeout(() => {
                          document.querySelector("[close-message='1']").focus();                          
                        }, 100);
                        
                        return setShowExtraTextA(true)
                      }
                    }}
                  >
                    {t('questions.9.read_message_text')}
                  </div>
                </div>
              </div>

              <div className={`wave b ${showExtraTextB && 'extra'}`} data-path={wrongSound}>
                <div className={`extra-text ${!showExtraTextB && 'hidden'}`}>
                  <span role='button' tabIndex={0} className="icon close-helper" close-message="2"
                    onClick={() => setShowExtraTextB(false)} 
                    onKeyDown={(evt) => {
                      if (evt?.keyCode === 13 || evt?.keyCode === 32) {
                        setTimeout(() => {
                          document.querySelector("[message='2']").focus();                           
                        }, 100);
                        
                        return setShowExtraTextB(false)
                      }
                    }}
                  />
                  <div className="inner-text" id="text-b">
                    <p>{t('questions.9.extra_text_b')}</p>
                  </div>
                </div>
                <div tabIndex={-1} aria-hidden={'true'} className="wave-container" />
                <div className="wrap">
                  <button className="listen" onClick={() => setIsListeningB((isListeningB) => !isListeningB)}>{isListeningB ? t('questions.9.pause') : t('questions.9.listen')}</button>
                  <MultipleChoiceAnswer symbol={'B'} isCorrect={false} onClick={handleAnswer} />
                  <div tabIndex={0} className="read_message_text" message="2"
                    onClick={() => {
                      document.querySelector('[close-message="2"]').style.display = '';
                      document.querySelector('[close-message="2"]').setAttribute('tabindex', 0)
                      return setShowExtraTextB(true)
                    }}
                    onKeyDown={(evt) => {
                      if (evt?.keyCode === 13 || evt?.keyCode === 32) {
                        document.querySelector('[close-message="2"]').style.display = '';
                        document.querySelector('[close-message="2"]').setAttribute('tabindex', 0)

                        setTimeout(() => {
                          document.querySelector("[ close-message='2']").focus();                          
                        }, 100);
                        return setShowExtraTextB(true)
                      }
                    }}
                  >
                    {t('questions.9.read_message_text')}
                  </div>
                </div>
              </div>

            </div>
          </div>

          {hasAnswered && (
            <CorrectAnswer question={9} isPlaying={hasAnswered} scoreTier={3 - score} />
          )}
        </div>
      </section>
    </main>

  );
};

export default Question9;
